import React from 'react';
import PropTypes from 'prop-types';
import WorkflowWidget from '../../workflow/WorkflowWidget';

const WORKFLOW_NAME = 'ShellToIal2WalletMerge';

const WalletMergeWidget = ({
  mergeWidgetConfig,
  onExit,
  onComplete,
  onError,
}) => (
  <WorkflowWidget
    // Key by the disputed email so a new collision remounts the widget rather
    // than updating a live instance — keeps the mount-once effect correct
    // regardless of how the parent branches this slot.
    key={mergeWidgetConfig.collisionEmail}
    widgetManifest={mergeWidgetConfig.widgetManifest}
    bffBaseUrl={mergeWidgetConfig.bffBaseUrl}
    workflow={WORKFLOW_NAME}
    // The disputed email is known from the collision; no screen collects it.
    prefill={{ email: mergeWidgetConfig.collisionEmail }}
    onExit={onExit}
    onComplete={onComplete}
    onError={onError}
  />
);

WalletMergeWidget.propTypes = {
  mergeWidgetConfig: PropTypes.shape({
    widgetManifest: PropTypes.shape({
      widgets: PropTypes.object,
    }),
    bffBaseUrl: PropTypes.string,
    collisionEmail: PropTypes.string,
  }).isRequired,
  onExit: PropTypes.func,
  onComplete: PropTypes.func,
  onError: PropTypes.func,
};

WalletMergeWidget.defaultProps = {
  onExit: undefined,
  onComplete: undefined,
  onError: undefined,
};

export default WalletMergeWidget;
